import { customerOfferSecondaryClass } from './customer-offer-utils'
import { offerFieldClass } from './ui'

interface CustomerAssignmentTermsProps {
    redeemBy: string
    reason: string
    onDeadline: (value: string) => void
    onReason: (value: string) => void
}

export function CustomerAssignmentTerms({ redeemBy, reason, onDeadline, onReason }: CustomerAssignmentTermsProps) {
    return (
        <>
            <label className="block space-y-2 text-sm font-medium">
                <span>4. Redeem before</span>
                <input
                    type="datetime-local"
                    className={`${offerFieldClass} dark:[color-scheme:dark]`}
                    value={redeemBy}
                    onChange={(event) => onDeadline(event.target.value)}
                />
                <span className={`${customerOfferSecondaryClass} block font-normal`}>
                    {Intl.DateTimeFormat().resolvedOptions().timeZone}. This controls acceptance, not subscription duration.
                </span>
            </label>
            <label className="block space-y-2 text-sm font-medium">
                <span>5. Assignment reason</span>
                <textarea
                    className={offerFieldClass}
                    rows={3}
                    maxLength={500}
                    value={reason}
                    onChange={(event) => onReason(event.target.value)}
                    placeholder="Reason agreed with the customer"
                />
                <span className={`${customerOfferSecondaryClass} block font-normal`}>Recorded in this customer’s assignment history.</span>
            </label>
        </>
    )
}
